import {Component, inject}               from '@angular/core';
import {BodyConfIntf, BodyRecordLogIntf} from '@djsharkk/logr-types';
import {takeUntil}                       from 'rxjs';
import {MenuCrudPanelContentBase}        from '../../menu-crud-panel-content-base';
import {MenuCrudPanelTopComponent}       from '../menu-crud-panel-top.component';
import {MenuCrudPanelBodyService}        from './menu-crud-panel-body.service';

@Component({
			   selector   : 'app-menu-crud-panel-body-top',
			   imports    : [
				   MenuCrudPanelTopComponent
			   ],
			   templateUrl: './menu-crud-panel-body-top.component.html',
			   styleUrl   : './menu-crud-panel-body-top.component.css'
		   })
export class MenuCrudPanelBodyTopComponent extends MenuCrudPanelContentBase<BodyRecordLogIntf, BodyConfIntf> {

	svcMenuCrudBody = inject(MenuCrudPanelBodyService)

	constructor() {
		super('body', true);
		this.svcDataFactory.svcDataBody.bodyConf
			.pipe(takeUntil(this.destroy$))
			.subscribe(confs => {
				this.recordRowsConf = confs;
				this.recordConfBtns = confs.map((c, i) => ({
					uuid  : c.id as string,
					icon  : i.toString().padStart(2, `0`),
					text  : c.body.split('_'),
					func  : () => this.svcMenuCrudBody.toggleItemInSelected(c.body),
					active: () => this.svcMenuCrudBody.itemInSelected(c.body)
				})).sort((a, b) => b.icon.localeCompare(a.icon))
			})

	}


}
